import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Button, Stack } from '@mui/material'

import CheckCircle from '@mui/icons-material/CheckCircle'

import { TLGTypography } from '@components/TLGTypography'

import {
  containerSx,
  contentSx,
  getStartedForFreeButtonSx,
  heroLeftSideContentSx,
  heroSubtitleSx,
  heroTitleSx,
  overlaySx,
} from './styles'

const HeroSection = () => {
  const { t } = useTranslation()

  return (
    <Box data-testid="features-hero-section" sx={containerSx}>
      <Box sx={contentSx}>
        <Stack sx={heroLeftSideContentSx}>
          <TLGTypography
            responsiveVariant={{ xs: 'h5', md: 'h4' }}
            component="h1"
            sx={heroTitleSx}
          >
            {t(
              'Purpose-Built to save you the time and tediousness of vendor discovery research '
            )}
          </TLGTypography>
          <TLGTypography
            responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}
            component="h2"
            sx={heroSubtitleSx}
          >
            {t(
              'Hunting down reliable technology partners is a chore in itself when researching new projects. But it doesn’t have to be anymore.'
            )}
          </TLGTypography>

          <Button
            data-testid="hero-get-started-for-free-button"
            component={RouterLink}
            to="/signup"
            variant="contained"
            color="secondary"
            size="large"
            endIcon={<CheckCircle />}
            sx={getStartedForFreeButtonSx}
          >
            {t('Get Started for Free Now')}
          </Button>
        </Stack>
      </Box>
      <Box sx={overlaySx} />
    </Box>
  )
}

export { HeroSection }
